import { TopBar } from '@openx/components-table/ChipFilters/TopBar.tsx';
import type { FiltersConfig } from '@openx/types/chipFilters.ts';
import { CriteriaDimension } from '@openx/types/tableCriteria.ts';
import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import type { UsersListFilters } from '../../types.ts';

type FilterChange = {
  dimension: typeof CriteriaDimension.FILTERS;
  value: UsersListFilters;
};

interface Props {
  onChange: (filters: FilterChange) => void;
  filters: UsersListFilters;
  filtersConfig: FiltersConfig;
}

export const UsersTopBar = memo(({ onChange, filtersConfig, filters }: Props) => {
  const { t } = useTranslation();

  const handleFiltersChange = useCallback(
    (newFilters: UsersListFilters) => {
      onChange({
        dimension: CriteriaDimension.FILTERS,
        value: newFilters,
      });
    },
    [onChange]
  );

  return (
    <TopBar
      filters={filters}
      onChange={handleFiltersChange}
      searchText={t('Search Name or ID')}
      chipFiltersConfig={filtersConfig}
    />
  );
});
